import { Route, Redirect } from "react-router-dom";
import Navbar from "../Components/Pages/Home/NavbarIndex.js"
import Footer from "../Components/Pages/Home/FooterIndex.js";

const AppRoute = ({
  component: Component,
  isAuthProtected,
  pageId,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Navbar />
          <Component {...props} />
          <Footer />
        </>
      )}
    />
  );
};

export default AppRoute;
